import React from 'react'
import { hooks } from '@front/volcanion'

const withContainer = Component => props => {
  const [selectedCompany] = hooks.useGlobalState('persist.selectedCompany')

  const [companyservices] = hooks.useModelSearch('companyservice', 'get', {
    initial_filter: { contract: { company: selectedCompany }, status: ['active'] },
    forced_filter: { contract: { company: selectedCompany }, status: ['active'] },
    watchers: [selectedCompany],
    default_limit: -1
  })
  const [companycontracts] = hooks.useModelSearch('companycontract', 'get', {
    initial_filter: { company: selectedCompany, status: ['active'] },
    forced_filter: { company: selectedCompany, status: ['active'] },
    watchers: [selectedCompany],
    default_limit: -1
  })
  const [companyusers] = hooks.useModelSearch('companyuser', 'get', {
    initial_filter: { company: selectedCompany, status: ['active'] },
    forced_filter: { company: selectedCompany, status: ['active'] },
    watchers: [selectedCompany],
    default_limit: -1
  })

  const services = (companyservices || []).length
  const contracts = (companycontracts || []).length
  const users = (companyusers || []).length

  const mergedProps = {
    services,
    contracts,
    users
  }

  return (
    <Component {...mergedProps} {...props} />
  )
}

export default withContainer